import { Component, OnInit, HostListener } from '@angular/core';
@Component({
  selector: 'app-contexto-organizacion',
  templateUrl: './contexto-organizacion.component.html',
  styleUrls: ['./contexto-organizacion.component.css']
})
export class ContextoOrganizacionComponent {
  pdfHeight: string = '500px'; 

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.calculatePdfHeight();
  }

  ngOnInit(): void {
    this.calculatePdfHeight();
  }

  calculatePdfHeight(): void {
    const windowHeight = window.innerHeight;
    const pdfContainerHeight = 500;/* Altura de otros elementos si es necesario */;
    this.pdfHeight = (windowHeight - pdfContainerHeight) + 'px';
  }
}